var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{class:_vm.styles,attrs:{"small":"","icon":"","flat":"","color":"primary","disabled":_vm.disabled},on:{"click":_vm.pop}},[_c('v-icon',[_vm._v("undo")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }